module.exports = __webpack_public_path__ + "static/media/303ColumnLabel--15.7d133b80.svg";